import request from '@/utils/request'

// 审核待办数量统计（视频审核、医师/医院/科室认证待处理数量）
export function countAuditTodo () {
  return request({
    url: '/platform/auditTodo/countPending',
    method: 'get'
  })
}
